<template>
  <div class="app-container">
    <mu-tabs class="tabs-box" :value.sync="active" inverse :indicator-color="themeConfig.dark" :color="themeConfig.dark" :text-color="themeConfig.dark"  center>
      <mu-tab class="tabs-item" :value="0">礼包</mu-tab>
      <mu-tab class="tabs-item" :value="1">存号箱</mu-tab>
    </mu-tabs>
    <div v-loading="loading" v-if="active === 0">
      <ul>
        <li class="item-box" v-for="(item, index) in unreceivedGiftList" :key="index">
          <div class="top-box">
            <div class="title">
              <div class="img-box">
                <img :src="item.game_icon ? item.game_icon : require('@/assets/img/gift.png')">
              </div>
              <div class="bd-title">
                <p class="bd" :class="{'lh66' : item.end_time === '0'}">{{item.giftbag_name}}</p>
                <p class="time" v-if="item.end_time !== '0'">{{item.end_time}}</p>
              </div>
            </div>
            <mu-button :color="themeConfig.dark" :textColor="themeConfig.light" small @click="getGift(item)" v-loading="btnLoading">
              领取
            </mu-button>
          </div>
          <div class="content">
            <p>{{item.details}}</p>
          </div>
        </li>
      </ul>
      <div class="img-bot" v-if="!loading && unreceivedGiftList.length === 0">
        <img :src="require(`@/assets/img/${theme[2].imgUrl}/Syg_icon_tewtsdf.png`)">
      </div>
    </div>
    <div v-loading="loading" v-if="active === 1">
      <ul>
        <li class="item-box" v-for="(item, index) in receivedGiftList" :key="index">
          <div class="top-box">
            <div class="title">
              <div class="img-box">
                <img :src="item.game_icon ? item.game_icon : require('@/assets/img/gift.png')">
              </div>
              <div class="bd-title">
                <p class="bd" :class="{'lh66' : item.end_time === '0'}">{{item.giftbag_name}}</p>
                <p class="time" v-if="item.end_time !== '0'">{{item.end_time}}</p>
              </div>
            </div>
            <mu-button :color="themeConfig.dark" :textColor="themeConfig.light" small @click="copy(item.code)">
              复制
            </mu-button>
          </div>
          <div class="content">
            <p>{{item.details}}</p>
          </div>
          <p class="gift-p">礼包码：<span :style="`color: ${themeConfig.dark}`">{{item.code}}</span></p>
        </li>
      </ul>
      <div class="img-bot" v-if="!loading && receivedGiftList.length === 0">
        <img :src="require(`@/assets/img/${theme[2].imgUrl}/Syg_icon_tewt.png`)">
      </div>
    </div>
    <!-- 领取礼包盒的dialog -->
    <mu-dialog width="300" :open.sync="openGift" :esc-press-close="false" :overlay-close="false">
      <div class="dialog-box">
        <div class="title-box">
          <p class="dl-title">领到的礼包</p>
          <mu-icon value="close" class="close" @click="closeGift"></mu-icon>
        </div>
        <div class="dl-top">
          <div class="title-p">
            礼包码: <span :style="`background: ${themeConfig.light};color: ${themeConfig.dark}; border-color: ${themeConfig.dark}`">{{giftbag_code}}</span>
          </div>
          <div class="tac">
            <mu-button :color="themeConfig.dark" full-width :textColor="themeConfig.light" small @click="copy(giftbag_code)">
              一键复制
            </mu-button>
          </div>
        </div>
        <div class="dl-bot">
          <p class="h3">使用方法</p>
          <p>一键复制礼包码</p>
          <p>进入游戏的福利界面</p>
          <p>长按黏贴礼包码兑换</p>
        </div>
      </div>
    </mu-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { giftBagList, getGiftBag } from '@/api/giftBagList'
import { newPromise } from '@/utils'
export default {
  name: 'Gift',
  data () {
    return {
      loading: false,
      btnLoading: false,
      game_icon: '',
      giftbag_code: '',
      openGift: false,
      active: 0
    }
  },
  mounted () {
    if (!this.giftStatus) {
      this.giftBagList()
    }
  },
  computed: {
    ...mapGetters([
      'themeConfig',
      'theme',
      'init',
      'receivedGiftList', //  已领取礼包列表
      'unreceivedGiftList', // 未领取礼包列表
      'giftStatus' //  用于防止多次请求
    ])
  },
  methods: {
    async giftBagList () {
      this.loading = true
      const res = await newPromise(giftBagList, { game_id: this.$store.getters.init.identity })
      this.loading = false
      if (res.ret !== 1) {
        this.$toast.error(res.msg ? res.msg : '请求错误')
      } else {
        if (res.data) {
          this.$store.commit('SET_RECEIVEDLIST', res.data.received_gift_list || [])
          this.$store.commit('SET_UNRECEIVEDLIST', res.data.unreceived_gift_list || [])
          this.$store.commit('SET_GIFTSTATUS', true)
        }
      }
    },
    async getGift (item) {
      this.btnLoading = true
      const res = await newPromise(getGiftBag, { game_id: this.$store.getters.init.identity, type: item.type_id })
      this.btnLoading = false
      if (res.ret !== 1) {
        this.$toast.error(res.msg ? res.msg : '请求错误')
      } else {
        this.giftbag_code = res.data
        this.$toast.success('领取礼包成功')
        this.openGift = true
      }
    },
    closeGift () {
      this.openGift = false
      this.giftBagList()
    },
    copy (item) {
      this.$copyText(item).then(() => {
        this.$toast.success('复制成功')
      }).catch((e) => {
        this.$toast.error('复制失败')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.app-container {
  position: relative;
}
.mu-raised-button {
  min-width: 60px;
}
.item-box {
  padding: .2rem 0;
  margin: 0 .4rem;
  border-bottom: 1px solid #E5E5E5;
  .top-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      display: flex;
    }
    .bd {
      font-size: .24rem;
      color: #333;
    }
    .lh66 {
      line-height: .66rem;
    }
    .time {
      font-size: .2rem;
      color: #999;
    }
    .img-box {
      width: .56rem;
      height: .56rem;
      margin-top: .1rem;
      margin-right: .2rem;
      border-radius: .1rem;
      img {
        display: block;
        width: 100%;
      }
    }
  }
  .gift-p {
    margin-top: .18rem;
    font-size: .2rem;
    color: #999999;
  }
  .content {
    color: #999;
    font-size: .2rem;
    line-height: .3rem;
    margin-top: .2rem;
  }
}
.img-bot {
  width: 2rem;
  margin: .6rem auto;
  img {
    width: 100%;
    display: block;
  }
}
.dl-title {
  font-size: .26rem;
  color: #57534E;
  text-align: center;
  width: 100%;
  padding: .3rem 0;
}
.title-box {
  position: absolute;
  top: -22px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  .close {
    position: absolute;
    right: -10px;
    top: 16px;
    font-size: .3rem;
    color: #CCCBCA;
  }
}
.dialog-box {
  position: relative;
  .dl-top {
    padding-top: .5rem;
    text-align: center;
    padding-bottom: .34rem;
    border-bottom: 1px solid #eee;
    margin-bottom: .36rem;
    .title-p {
      font-size: .2rem;
      color: #999;
      line-height: .3rem;
      padding-bottom: .34rem;
      span {
        margin-left: .12rem;
        border: 1px dashed;
        display: inline-block;
        padding: .04rem .1rem;
        border-radius: .08rem;
      }
    }
    .tac {
      width: 70%;
      margin: 0 auto;
    }
  }
  .dl-bot {
    p {
      font-size: .2rem;
      color: #787D8F;
      left: .3rem;
    }
    .h3 {
      font-size: .24rem;
      color: #333;
      padding-bottom: .2rem;
    }
  }
}
</style>
